<template>
  <a-list bordered :data-source="props.list">
    <template #renderItem="{ item, index }">
      <a-list-item
        v-if="!item.hide"
        class="aside-one"
        :class="props.tab === item.id && 'item-selected'"
        @click="onClick(item.id)"
      >
        <p :class="index == 0 && 'font-medium'">{{ item.content }}</p>
      </a-list-item>
    </template>
  </a-list>
</template>

<script setup lang="ts">
import { windowScroll } from "@/utils/helper";
import { useRouter } from "vue-router";
import type { AsideProps } from "./type";

const router = useRouter();
const props = defineProps<AsideProps>();
const emit = defineEmits(["update:modelValue"]);

function onClick(id: number) {
  if (id === 0) {
    window.location.href = import.meta.env.VITE_APP_LEGISLATION_URL;
    return;
  }

  router.replace({ query: { tab: id } });
  windowScroll();
}
</script>
